import styled, { css } from 'styled-components';

export const LoaderWrapper = styled.div<{ centered?: boolean }>`
  .MuiCircularProgress-root circle {
    stroke: rgb(236, 105, 26);
  }

  ${(props) =>
    props.centered &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 0;
    `}
`;
